// extracted by mini-css-extract-plugin
export default {"header":"OrderHistory_header__iHRsL"};